module.exports = __webpack_public_path__ + "static/media/Nintendo-Logo.9dfada4c.png";